import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Paperclip } from "lucide-react";

// Overlay para un contenedor con position: relative
export const FileDropOverlay = ({ inset = "8px" }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "absolute",
        inset,
        zIndex: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        borderRadius: "8px",
        border: `2px dashed ${theme.palette.primary.main}`,
        backgroundColor: "rgba(129, 83, 255, 0.08)",
        backdropFilter: "blur(2px)",
        color: theme.palette.primary.main,
        pointerEvents: "none",
      }}
    >
      <Paperclip size={18} />
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Suelta los archivos para adjuntarlos
      </Typography>
    </Box>
  );
};

export default FileDropOverlay;
